const cookiesStatement = {
  id: 'cookies-statement-ru',
  title: 'Заявление о cookie',
  body: `
    <p>Сайт business.super-ego.info использует файлы cookie для повышения производительности и улучшения
        вашего пользовательского опыта, для предоставления определенных пользовательских функций,
        а также для того, чтобы отличать вас от других пользователей при использовании нашего веб-сайта
        и других продуктов и услуг.
    </p>
    <h4>Что такое cookie?</h4>
    <p>Файл cookie - это небольшой файл, который хранится локально в веб-браузере
        или файловой системе на вашем компьютере или мобильном устройстве.
        Файлы cookie используются всеми веб-сайтами и имеют несколько различных функций.
        Мы используем следующие типы файлов cookie:
    </p>
    <h4>Функциональные cookie</h4>
    <p>Это файлы cookie, которые необходимы для работы наших сервисов.
        Они включают, например, файлы cookie, которые позволяют вам входить
        в безопасные зоны нашего веб-сайта и получать доступ к информации Super Ego Business.
    </p>
    <h4>Аналитические cookies</h4>
    <p>Эти файлы cookie важны для нашего веб-сайта для получения статистики, оценки размера аудитории, понимания использования нашего веб-сайта и для улучшения услуг, которые мы предоставляем нашим пользователям.</p>
  `
}

export default cookiesStatement
